export const LogError = (api, errorMessage) => {
    return api.get(`/api/v1/Logger/logError?errorMessage=${errorMessage}`)
}